/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import Filter from './filter/component';
import { shape, string, func, arrayOf } from 'prop-types';

const Regions = ( props ) => {

    const { emit, filters, clearChart } = props;

    const [ activeFilters, setActiveFilters ] = useState( [] );

    const onFilterChange = ( val ) => {

        if ( val && activeFilters.length < 2 ) {

            setActiveFilters( ( prev ) => [ ...prev, val ] );

        }

        clearChart();

    };

    const removeActiveFilter = ( val ) => {

        const curState = activeFilters.slice();

        curState.splice( curState.indexOf( val ), 1 );

        setActiveFilters( curState );

        clearChart();

    };

    const renderFilters = () => {

        return filters.map( ( filter, idx ) => {

            return (
                <div key={ `${ filter.name }-${ idx }` }>
                    <h3>{ filter.name }</h3>

                    <div className={ activeFilters.length >= 2 ? 'disabled' : '' }>
                        <Filter
                            key={ filter.name }
                            placeholder={ filter.placeholder }
                            activeFilters={ activeFilters }
                            filter={ filter }
                            labelId='filter-title'
                            onChange={ onFilterChange }
                        />
                    </div>
                </div>
            );

        } );

    };

    useEffect( () => {

        emit( activeFilters );

    }, [ activeFilters ] );

    const clearAllRegions = () => {

        setActiveFilters( [] );
        clearChart();

    };

    return (
        <div className='ude-regions'>
            <div className='ude-regions-header'>
                <h2>Regions</h2>
                <span>(select up to 2)</span>
            </div>

            <div className='ude-regions-filterwrapper'>
                { renderFilters() }
            </div>

            {
            activeFilters.length > 0 &&
            <div className='ude-regions-activefilters'>
                <h4>Selected:</h4>
                { activeFilters.map( ( filter, idx ) => {

                    return (
                        <div key={ `${ filter.label }-${ idx }` } className='ude-regions-activefilters-cancellable'>
                            <span>
                                <h4>{ filter.group }:</h4>
                                <p>{ filter.label }</p>
                            </span>

                            <a onClick={ () => removeActiveFilter( filter ) }><img src='/assets/images/svg/icon-utility/x.svg' alt='Remove selection' /></a>
                        </div>
                    );

                } ) }

                <a onClick={ clearAllRegions }>Clear All Regions</a>
            </div>
            }
        </div>
    );

};

Regions.propTypes = {
    filters: arrayOf ( shape ( {
        name: string.isRequired,
        placeholder: string.isRequired,
        shortName: string.isRequired,
        facets: arrayOf( shape( {
            filename: string.isRequired,
            id: string.isRequired,
            name: string.isRequired
        } ) ).isRequired
    } ) ).isRequired,
    emit: func.isRequired,
    clearChart: func.isRequired
};

export default Regions;